import { motion } from "framer-motion";
import { ArrowUpRight, BadgeCheck } from "lucide-react";
import { certifications } from "@/data/portfolio";
import { Section } from "@/components/Section";

export const Certifications = () => (
  <Section id="certifications" index="03" title="Certifications">
    <div data-testid="certifications-list" className="border-b border-white/10">
      {certifications.map((c, i) => (
        <motion.a
          key={c.id}
          href={c.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`certification-${c.id.toLowerCase()}`}
          initial={{ opacity: 0, x: -16 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-30px" }}
          transition={{ duration: 0.4, delay: i * 0.03 }}
          className="group grid grid-cols-[auto_1fr_auto] items-center gap-4 border-t border-white/10 py-5 transition-colors duration-300 hover:bg-white/[0.02] md:grid-cols-[48px_1.4fr_1fr_auto_auto] md:gap-8"
        >
          <span className="font-mono text-xs text-zinc-600">{String(i + 1).padStart(2, "0")}</span>
          <div className="flex items-center gap-3">
            <BadgeCheck className="h-4 w-4 shrink-0 text-cyan-400/70" />
            <span className="font-display text-base font-bold text-white transition-colors duration-300 group-hover:text-cyan-400 md:text-lg">
              {c.name}
            </span>
          </div>
          <span className="hidden font-mono text-xs uppercase tracking-wider text-zinc-500 md:block">
            {c.issuer} — {c.issued}
          </span>
          <span className="hidden font-mono text-[10px] text-zinc-600 lg:block">ID {c.id}</span>
          <ArrowUpRight className="h-4 w-4 text-zinc-600 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-cyan-400" />
        </motion.a>
      ))}
    </div>
    <p className="mt-6 font-mono text-xs text-zinc-600">
      9 × Google (Coursera) · 1 × Udemy — credential IDs linked.
    </p>
  </Section>
);
